import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { locationItem as deleteLocation } from '../utils/urls';
import { showSuccessToast } from 'utils/showToast';

import { ErrorModal } from 'types/modalTypes';

export async function deleteLocations({
  locId,
  accountId,
}: TVariables): Promise<Response> {
  return fetch(deleteLocation(locId, accountId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
}

type TError = ErrorModal;

type TSnapshot = unknown;

type TVariables = {
  locId: number;
  accountId: number;
};

function useDeleteLocations(
  locId: number,
  accountId: number,
): UseMutationResult<void, TError, TVariables, TSnapshot> {
  const queryClient = useQueryClient();
  return useMutation(async () => {
    await deleteLocations({
      locId,
      accountId,
    });
    queryClient.invalidateQueries('locations_list');
    showSuccessToast({
      message: 'Location deleted successfully.',
    });
  });
}

export { useDeleteLocations };
